"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var axios_retry_1 = __importDefault(require("axios-retry"));
var util_1 = require("./util");
var constants_1 = require("./constants");
var TailorApiService = /** @class */ (function () {
    function TailorApiService(accessKey, env) {
        this.http = axios_1.default.create({
            baseURL: this.getBaseUrl(env),
            headers: {
                common: {
                    Authorization: accessKey,
                },
            },
        });
        axios_retry_1.default(this.http, {
            retries: 10,
            retryDelay: axios_retry_1.default.exponentialDelay,
            shouldResetTimeout: true,
        });
    }
    /**
     * createJob - POST
     * A POST on /jobs requires an authorization header. This header is available to users who have registered.
     * A POST on /jobs also requires a json object containing an actions element and a flex element.
     * The actions and flex data are then associated to a newly created job.
     * After the flex and actions elements passes validation they will be associated to that newly created job.
     * The job id in the form of a hash will be returned, and will be used to hit the /upload endpoint.
     * @param config A valid configuration object. See documentation in Tailor API Postman collection
     */
    TailorApiService.prototype.createJob = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.post('jobs', config)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign({}, response)];
                }
            });
        });
    };
    /**
     * updateJob - PUT
     * This endpoint requires the same JSON body that is required in the creation of the job.
     * The same validation rules apply to the modification of a job, that apply to the creation of the job.
     * The job must be in the initial status for it to be updatable.
     * @param jobId Job to update. Must be a valid job id
     * @param config
     */
    TailorApiService.prototype.updateJob = function (jobId, config) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.put("jobs/" + jobId, config)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign({}, response)];
                }
            });
        });
    };
    /**
     * uploadImage - POST
     * This endpoint is used for uploading files and associating them to a job.
     * In addition to the file being uploaded, jobId must be specified (to associate the uploaded file with).
     * upload_reference must also be specified, indicating which file this is with respect to the total number of uploads.
     * Once all files are uploaded, actions can begin working on those files.
     * @param jobId Job to associate uploaded files to
     * @param file The image file to be associated with an action
     * @param uploadReference A number indicating which of the files this upload corresponds to. For example this could be 3, as in this is the third out of five files
     */
    TailorApiService.prototype.uploadImage = function (jobId, file, uploadReference, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, CancelToken, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        formData = new FormData();
                        CancelToken = axios_1.default.CancelToken;
                        this.cancelToken = CancelToken.source();
                        formData.append('upload', file);
                        return [4 /*yield*/, this.http.post('upload/image', formData, {
                                params: {
                                    job_id: jobId,
                                    upload_reference: uploadReference,
                                },
                                onUploadProgress: onProgress,
                                cancelToken: this.cancelToken.token,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign({}, response)];
                    case 2:
                        err_1 = _a.sent();
                        this.handleUploadError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TailorApiService.prototype.uploadVideo = function (file, config, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var isThirdPartyCookiesSupported, filetransferFinished, startOffset, job_id, _loop_1, this_1, finishedResponse, err_2, job_id, response, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isThirdPartyCookiesSupported = !!window['third_party_cookies_enabled_ts'];
                        if (!isThirdPartyCookiesSupported) return [3 /*break*/, 11];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 9, , 10]);
                        filetransferFinished = false;
                        startOffset = '0';
                        return [4 /*yield*/, this.createJob(config)];
                    case 2:
                        job_id = (_a.sent()).data.job_id;
                        // Start Phase - Signal to Tailor that a transfer is about to start
                        return [4 /*yield*/, this.resumableUploadStart(job_id, file.size, file.name, '1')];
                    case 3:
                        // Start Phase - Signal to Tailor that a transfer is about to start
                        _a.sent();
                        _loop_1 = function () {
                            var offset, fileChunk, chunkedOnProgress, transferResponse, start_offset, end_offset;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        offset = Number(startOffset);
                                        fileChunk = util_1.getFileChunk(file, offset, constants_1.CHUNK_FILE_SIZE);
                                        chunkedOnProgress = function (_a) {
                                            var loaded = _a.loaded;
                                            var totalLoaded = offset + loaded;
                                            if (typeof onProgress === 'function') {
                                                onProgress({ loaded: totalLoaded, total: file.size });
                                            }
                                        };
                                        return [4 /*yield*/, this_1.resumableUploadTransfer(job_id, fileChunk, startOffset, '1', chunkedOnProgress)];
                                    case 1:
                                        transferResponse = (_a.sent()).data;
                                        start_offset = transferResponse.start_offset, end_offset = transferResponse.end_offset;
                                        if (start_offset === end_offset) {
                                            filetransferFinished = true;
                                        }
                                        else {
                                            startOffset = start_offset;
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 4;
                    case 4: return [5 /*yield**/, _loop_1()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        if (!filetransferFinished) return [3 /*break*/, 4];
                        _a.label = 7;
                    case 7: return [4 /*yield*/, this.resumableUploadFinish(job_id, '1')];
                    case 8:
                        finishedResponse = (_a.sent()).data;
                        return [2 /*return*/, __assign({ job_id: job_id }, finishedResponse)];
                    case 9:
                        err_2 = _a.sent();
                        this.handleUploadError(err_2);
                        return [3 /*break*/, 10];
                    case 10: return [3 /*break*/, 15];
                    case 11:
                        _a.trys.push([11, 14, , 15]);
                        return [4 /*yield*/, this.createJob(config)];
                    case 12:
                        job_id = (_a.sent()).data.job_id;
                        return [4 /*yield*/, this.upload(job_id, file, '1', onProgress)];
                    case 13:
                        response = (_a.sent()).data;
                        return [2 /*return*/, __assign({ job_id: job_id }, response)];
                    case 14:
                        err_3 = _a.sent();
                        this.handleUploadError(err_3);
                        return [3 /*break*/, 15];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * upload - POST
     * This endpoint is used for uploading files and associating them to a job.
     * In addition to the file being uploaded, jobId must be specified (to associate the uploaded file with).
     * upload_reference must also be specified, indicating which file this is with respect to the total number of uploads.
     * Once all files are uploaded, actions can begin working on those files.
     * @param jobId Job to associate uploaded files to. Must be a valid job id
     * @param file The video file to be associated with an action. Must be a valid video file uploaded via multipart/form-data
     * @param uploadReference A number indicating which of the files this upload corresponds to. For example, this could be 3; as in this is the third out of five files. min: 1, max: total number of uploads
     */
    TailorApiService.prototype.upload = function (jobId, file, uploadReference, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, CancelToken, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        CancelToken = axios_1.default.CancelToken;
                        this.cancelToken = CancelToken.source();
                        formData.append('upload', file);
                        return [4 /*yield*/, this.http.post('upload', formData, {
                                params: {
                                    job_id: jobId,
                                    upload_reference: uploadReference,
                                },
                                onUploadProgress: onProgress,
                                cancelToken: this.cancelToken.token,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign({}, response)];
                }
            });
        });
    };
    /**
     * resumableUploadStart - POST
     * The client will request the server to initialize a resumable upload with a "start"/"force_start" phase request.
     * At anytime a phase="force_start" can be requested which will delete the localfile and the upload can start over.
     * Also, if a phase="start" request is made, an upload that has previous gotten to a specific point and the filesize/filename are the same,
     * the server will return json requesting the bytes it needs next to continue this upload.
     * @param jobId Job to associate uploaded files to. Must be a valid job id
     * @param fileSize file size in bytes of the video
     * @param fileName name of the uploaded file
     * @param uploadReference A number indicating which of the files this upload corresponds to. For example this could be 3, as in this is the third out of five files
     * @param forceStart A boolean to indicate if the upload should force_start (starts the upload over again)
     */
    TailorApiService.prototype.resumableUploadStart = function (jobId, fileSize, fileName, uploadReference, forceStart) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            job_id: jobId,
                            upload_phase: forceStart ? 'force_start' : 'start',
                            file_size: fileSize,
                            filename: fileName,
                            upload_reference: uploadReference,
                        };
                        return [4 /*yield*/, this.resumableUpload(params)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign({}, response)];
                }
            });
        });
    };
    /**
     * resumableUploadTransfer - POST
     * Endpoint to transfer file chunks. resumableUploadStart() must be called first to initiate the process.
     * This endpoint must be called until all chunks are transferred.
     * @param jobId Job to associate uploaded files to. Must be a valid job id
     * @param file The video file to be associated with an action. Must be a valid video file uploaded via multipart/form-data
     * @param startOffset Position of bytes (inclusive) for upload
     * @param uploadReference A number indicating which of the files this upload corresponds to. For example this could be 3, as in this is the third out of five files
     * @param onProgress callback function that will be called multiple times throughout the upload
     */
    TailorApiService.prototype.resumableUploadTransfer = function (jobId, file, startOffset, uploadReference, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            job_id: jobId,
                            upload_phase: 'transfer',
                            start_offset: startOffset,
                            upload_reference: uploadReference,
                        };
                        return [4 /*yield*/, this.resumableUpload(params, file, onProgress)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign({}, response)];
                }
            });
        });
    };
    /**
     * resumableUploadFinish - POST
     * Endpoint to signal that all chunks have been transferred and the upload will be validated.
     * A success response from this endpoint indicates that the upload has been validated and actions can begin working on the file
     * @param jobId Job to associate uploaded files to. Must be a valid job id
     * @param uploadReference A number indicating which of the files this upload corresponds to. For example this could be 3, as in this is the third out of five files
     */
    TailorApiService.prototype.resumableUploadFinish = function (jobId, uploadReference) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            job_id: jobId,
                            upload_phase: 'finish',
                            upload_reference: uploadReference,
                        };
                        return [4 /*yield*/, this.resumableUpload(params)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign({}, response)];
                }
            });
        });
    };
    /**
     * resumableUpload - POST
     * This endpoint is used for uploading files in parts and associating them to a job.
     * The client will request the server to initialize a resumable upload with a "start"/"force_start" phase request.
     * The server will respond with a json object indicating the bytes it needs and the client will request those bytes for the file with "transfer" phase requests.
     * Client must return the bytes requested inclusively. This will go back and forth until all bytes are uploaded to the server.
     * When this process is complete (start_offset will equal end_offset in server response), the client will make a "finish" phase request which will validate the video.
     * Once the phase="finish" request is successfully validated, actions can begin working on the file.
     * @param params an object containing the required query params (See Postman collection)
     * @param file The media file to be associated with an action
     * @param onProgress callback function that will be called multiple times throughout the upload
     */
    TailorApiService.prototype.resumableUpload = function (params, file, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, CancelToken, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        CancelToken = axios_1.default.CancelToken;
                        this.cancelToken = CancelToken.source();
                        if (file) {
                            formData.append('file', file);
                        }
                        return [4 /*yield*/, this.http.post('resumable_upload/video', formData, {
                                params: params,
                                onUploadProgress: onProgress,
                                cancelToken: this.cancelToken.token,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign({}, response)];
                }
            });
        });
    };
    /**
     * getJob - GET
     * Retrieves or updates a single Job object and returns its details. You will only be able to retrieve your own jobs.
     * @param jobId Job to associate uploaded files to
     */
    TailorApiService.prototype.getJob = function (jobId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get("jobs/" + jobId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign({}, response)];
                }
            });
        });
    };
    /**
     * startJob - POST
     * Signals a job to start processing.
     * Validations will run to ensure the job is ready for processing. For example, if there are an incorrect number of files for the job,
     * or if the files are incompatible in some way, a prompt will ask to reupload files in a way that satisfies validations. If validations pass, you will receive a response containing the job and the status.
     * @param jobId Job to start processing
     */
    TailorApiService.prototype.startJob = function (jobId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.post("jobs/" + jobId + "/start")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign({}, response)];
                }
            });
        });
    };
    /**
     * updateFlex - PUT
     * Updates flex data for a job
     * @param flexConfig - flex object to update
     */
    TailorApiService.prototype.updateFlex = function (jobId, flexConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.put("jobs/" + jobId + "/flex", flexConfig)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, __assign({}, response)];
                }
            });
        });
    };
    TailorApiService.prototype.cancelUpload = function () {
        if (!this.cancelToken)
            return;
        this.cancelToken.cancel(constants_1.USER_CANCEL_MESSAGE);
        this.cancelToken = axios_1.default.CancelToken.source();
    };
    /**
     * getBaseUrl
     * returns the correct endpoint to use based on environment
     * @param env environment (prod, dev, test)
     */
    TailorApiService.prototype.getBaseUrl = function (env) {
        var baseUrl = env === 'dev' || env === 'test' ? "https://tailor-" + env + ".telescope.tv/1.0/" : 'https://tailor.telescope.tv/1.0/';
        return baseUrl;
    };
    TailorApiService.prototype.handleUploadError = function (err) {
        var uploadError = new Error('TailorError');
        if (err.message === constants_1.USER_CANCEL_MESSAGE) {
            uploadError.data = {
                errorCodes: [constants_1.ERROR_CODES.CANCELED_BY_USER],
                messages: [constants_1.USER_CANCEL_MESSAGE],
            };
        }
        else if (!err.response) {
            // Network Error
            uploadError.data = { errorCodes: [], messages: [] };
        }
        else {
            // Server Response
            uploadError.data = __assign({}, err.response.data);
        }
        throw uploadError;
    };
    // Static Methods
    TailorApiService.getSupportedVideoTypes = function () {
        return __spreadArrays(constants_1.SUPPORTED_VIDEO_FORMATS);
    };
    TailorApiService.getSupportedImageTypes = function () {
        return __spreadArrays(constants_1.SUPPORTED_IMAGE_FORMATS);
    };
    TailorApiService.isSupportedVideoType = function (mimeType) {
        var ext = mimeType.split('/')[1];
        if (!ext)
            return false;
        return constants_1.SUPPORTED_VIDEO_FORMATS.indexOf(ext.toLowerCase()) > -1;
    };
    TailorApiService.isSupportedImageType = function (mimeType) {
        var ext = mimeType.split('/')[1];
        if (!ext)
            return false;
        return constants_1.SUPPORTED_IMAGE_FORMATS.indexOf(ext.toLowerCase()) > -1;
    };
    TailorApiService.isImage = function (mimeType) {
        return this.isSupportedImageType(mimeType);
    };
    TailorApiService.isVideo = function (mimeType) {
        return this.isSupportedVideoType(mimeType);
    };
    return TailorApiService;
}());
exports.default = TailorApiService;
